<template>
    <div class="loader-container">
        <div class="loader-text">
            <p>{{ upperText }}</p>
            <p>{{ lowerText }}</p>
            <div class="loader-spinner">
                <common-logo-spinner :width="88"></common-logo-spinner>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            upperText: { type: String, default: '' },
            lowerText: { type: String, default: '' },
        },
    }
</script>
